import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { useGenderPopup } from "../context/GenderPopupContext";

const HARBIZ_LINKS = {
  power: "https://app.harbiz.io/checkout-form/retomastercom?product=wmZBP2jzcoH4GekYz&lang=es",
  booty: "https://app.harbiz.io/checkout-form/retomastercom?product=dhuLyuK5JL54YsqND&lang=es",
};

export default function GenderPopup() {
  const { t } = useI18n();
  const { open, setOpen } = useGenderPopup();

  const handleChoice = (plan) => {
    setOpen(false);
    window.open(HARBIZ_LINKS[plan], "_blank", "noopener");
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[60] flex items-center justify-center px-4 bg-black/80 backdrop-blur-sm"
          data-testid="gender-popup"
          onClick={(e) => e.target === e.currentTarget && setOpen(false)}
        >
          <motion.div
            initial={{ scale: 0.9, y: 20 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.95, y: 10 }}
            className="relative w-full max-w-lg glass-card p-8 sm:p-10 premium-border-wrap text-center"
          >
            <button
              onClick={() => setOpen(false)}
              className="absolute top-4 right-4 text-zinc-500 hover:text-white transition"
              data-testid="gender-popup-close"
              aria-label="Close"
            >
              <X size={20} />
            </button>
            <div className="text-xs tracking-[0.4em] uppercase text-[#FF6B00] mb-3">
              {t.exitPopup.badge}
            </div>
            <h3 className="font-display text-3xl sm:text-4xl uppercase leading-tight">
              {t.exitPopup.title}
            </h3>
            <p className="mt-3 text-zinc-300 text-sm">{t.exitPopup.subtitle}</p>
            <div className="mt-8 grid grid-cols-2 gap-4">
              <button
                onClick={() => handleChoice("power")}
                className="flex flex-col items-center gap-3 p-6 rounded-xl border border-zinc-700 hover:border-[#FF6B00] transition-all hover:bg-[#FF6B00]/5 group"
                data-testid="gender-popup-power"
              >
                <span className="text-4xl">💪</span>
                <span className="font-display text-lg uppercase tracking-wider group-hover:text-[#FF6B00] transition">
                  {t.exitPopup.male}
                </span>
                <span className="text-xs text-zinc-400 uppercase tracking-wide">POWER</span>
              </button>
              <button
                onClick={() => handleChoice("booty")}
                className="flex flex-col items-center gap-3 p-6 rounded-xl border border-zinc-700 hover:border-[#FF6B00] transition-all hover:bg-[#FF6B00]/5 group"
                data-testid="gender-popup-booty"
              >
                <span className="text-4xl">🍑</span>
                <span className="font-display text-lg uppercase tracking-wider group-hover:text-[#FF6B00] transition">
                  {t.exitPopup.female}
                </span>
                <span className="text-xs text-zinc-400 uppercase tracking-wide">BOOTY</span>
              </button>
            </div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="mt-6 w-full text-xs text-zinc-500 hover:text-white transition tracking-[0.25em] uppercase"
            >
              {t.exitPopup.close}
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
